var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 50,
    fill: "none",
    viewBox: "0 0 149 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m22.5 34-1.646 1.136a2 2 0 0 0 3.13.204L22.5 34ZM51.4 2l1.865-.722a2 2 0 0 0-3.35-.618L51.4 2ZM69 47.5l-1.865.721a2 2 0 0 0 3.584.302L69 47.5ZM92.5 8l1.793-.885a2 2 0 0 0-3.512-.138L92.5 8ZM112 47.5l-1.793.885a2 2 0 0 0 3.735-.407L112 47.5Zm8-32.5 1.088-1.678a2.001 2.001 0 0 0-3.03 1.2L120 15Zm25.912 19.178a2 2 0 1 0 2.176-3.356l-2.176 3.356ZM.854 6.135l20 29 3.292-2.27-20-29-3.292 2.27Zm23.13 29.206 28.9-32L49.916.66l-28.9 32 2.968 2.68Zm25.55-32.62 17.6 45.5 3.731-1.442-17.6-45.5-3.73 1.443ZM70.72 48.524l23.5-39.5-3.438-2.046-23.5 39.5 3.438 2.046ZM90.707 8.885l19.5 39.5 3.586-1.77-19.5-39.5-3.586 1.77Zm23.235 39.093 8-32.5-3.884-.956-8 32.5 3.884.956Zm4.97-31.3 27 17.5 2.176-3.356-27-17.5-2.176 3.356Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -17,
    x2: 254,
    y1: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH8);
export default __webpack_public_path__ + "static/media/h8.d1bfd1911f255bab7d7337b1cf359379.svg";
export { ForwardRef as ReactComponent };